import {
    CREATE_TEAMS_ERROR,
    CREATE_TEAMS_LOADING,
    CREATE_TEAMS_SUCCESS,
    DELETE_TEAMS_ERROR,
    DELETE_TEAMS_LOADING,
    DELETE_TEAMS_SUCCESS,
    EDIT_TEAMS_ERROR,
    EDIT_TEAMS_LOADING,
    EDIT_TEAMS_SUCCESS,
    GET_TEAMS_ERROR,
    GET_TEAMS_LOADING,
    GET_TEAMS_SUCCESS,
    VIEW_TEAM_ERROR,
    VIEW_TEAM_LOADING,
    VIEW_TEAM_SUCCESS,
} from "../../../constant/actionTypes";
import {apiDelete, apiGet, apiPost, apiPut} from "../../../utils/apiRequests";
import ApiEndpoints from "../../../utils/ApiEndpoints";
import {toast} from "react-toastify";

export const getAllTeams = () => (dispatch) => {
    dispatch({type: GET_TEAMS_LOADING});

    apiGet(
        `${ApiEndpoints.teams.base}${ApiEndpoints.teams.all}`,
        (response) => {
            if (response.error === true) {
                dispatch({type: GET_TEAMS_ERROR, response: response.message});
                console.log("err", response.error);
            } else {
                dispatch({type: GET_TEAMS_SUCCESS, response: response});
                console.log("get teams response ===>>>>", response);
            }
        },
        (error) => {
            console.log("error ===>>>>", error);
            dispatch({type: GET_TEAMS_ERROR, response: error});
        }
    );
};

export const viewTeamDetails = (id) => (dispatch) => {
    dispatch({type: VIEW_TEAM_LOADING});
    apiGet(
        `$${ApiEndpoints.teams.base}${ApiEndpoints.teams.view}${id}`,
        (response) => {
            // console.log("view team details response ==============> ", response);
            if (response.error === true) {
                dispatch({type: VIEW_TEAM_ERROR, response: response.message});
            } else {
                dispatch({type: VIEW_TEAM_SUCCESS, response: response});
            }
        },
        (error) => {
            // console.log("error ===>>>>", error);
            dispatch({type: VIEW_TEAM_ERROR, response: error});
        }
    );
};

export const createTeam = (data) => (dispatch) => {
    dispatch({type: CREATE_TEAMS_LOADING});
    apiPost(
        `${ApiEndpoints.teams.base}${ApiEndpoints.teams.add}`,
        data,
        (response) => {
            // console.log("submit course response ....", response);

            if (response.error === true) {
                toast.error("Team create error");
                dispatch({type: CREATE_TEAMS_ERROR, response: response.message});
            } else {
                dispatch({type: CREATE_TEAMS_SUCCESS, response: response});
                toast.success("Team created");
            }
        },
        (error) => {
            dispatch({type: CREATE_TEAMS_ERROR, response: error});
            toast.error("Team create error");
        }
    );
};

export const deleteTeam = (id) => (dispatch) => {
    dispatch({type: DELETE_TEAMS_LOADING});
    apiDelete(
        `${ApiEndpoints.teams.base}${ApiEndpoints.teams.delete}${id}`,
        (response) => {
            if (response.error === true) {
                dispatch({type: DELETE_TEAMS_ERROR, response: response.message});
                toast.error("Team delete error");
            } else {
                dispatch({type: DELETE_TEAMS_SUCCESS, response: response});
                toast.success("Team deleted");
            }
        },
        (error) => {
            dispatch({type: DELETE_TEAMS_ERROR, response: error});
            toast.error("Team delete error");
        }
    );
};

export const editTeam = (id, data, navigate) => (dispatch) => {
    dispatch({type: EDIT_TEAMS_LOADING});
    apiPut(
        `${ApiEndpoints.teams.base}${ApiEndpoints.teams.edit}${id}`,
        data,
        (response) => {
            if (response.error === true) {
                dispatch({type: EDIT_TEAMS_ERROR, response: response.message});
                toast.error("Team update error");
            } else {
                dispatch({type: EDIT_TEAMS_SUCCESS, response: response});
                toast.success("Teams updated");
            }
        },
        (error) => {
            dispatch({type: EDIT_TEAMS_ERROR, response: error});
            toast.error("Team update error");
        }
    );
};
